import {WebHelpers} from "../utils/WebHelpers";

export interface ChainAddress {
    cashAddress: string; // the address starting with "bitcoincash:"
    slpAddress: string;
}

export class ChainTools {
    protected apiBasePath: string;
    protected webHelpers: WebHelpers;

    constructor(apiBasePath: string, webHelpers: WebHelpers) {
        this.apiBasePath = apiBasePath;
        this.webHelpers = webHelpers;
    }

    public createAddress(xpub: string, index: number): Promise<ChainAddress> {
        return new Promise<ChainAddress>((resolve, reject) => {
            const url = this.apiBasePath + "/create-address";
            let params = {
                xpub: xpub, // jQuery escapes if needed
                index: index
            }
            this.webHelpers.getApi(url, params, (data) => {
                if (data.data === undefined) {
                    reject({text: "invalid address response", res: data});
                    return;
                }

                resolve({
                    cashAddress: data.data.cash_address,
                    slpAddress: data.data.slp_address,
                });
            });
        })
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################
}
